import type { SortOption as BaseSortOption } from "$routes/inventory/_lib/sort-by-select";
import {
  StockTakeLotsSearchOrder,
  StockTakeSearchOrderDirection,
} from "elephant-web/gql";
import { useIntl } from "react-intl";

export interface StockTakeSortOption extends BaseSortOption {
  field: StockTakeLotsSearchOrder;
  direction?: StockTakeSearchOrderDirection;
}

export enum OngoingStockTakeSearchOrder {
  Name = "Name",
  LastStockTakeAt = "LastStockTakeAt",
  ExpiryDate = "ExpiryDate",
  MostRecentlyReviewed = "MostRecentlyReviewed",
}

function useSortByOptions(): Record<
  OngoingStockTakeSearchOrder,
  StockTakeSortOption
> {
  const { formatMessage } = useIntl();
  return {
    [OngoingStockTakeSearchOrder.Name]: {
      label: formatMessage({
        id: "inventory.stockTake.sort.option.alphabetical",
        defaultMessage: "A to Z",
      }),
      field: StockTakeLotsSearchOrder.Name,
    },
    [OngoingStockTakeSearchOrder.LastStockTakeAt]: {
      label: formatMessage({
        id: "inventory.stockTake.sort.option.last_stock_take_at",
        defaultMessage: "Last Stocktake",
      }),
      field: StockTakeLotsSearchOrder.LastStockTakeAt,
    },
    [OngoingStockTakeSearchOrder.MostRecentlyReviewed]: {
      label: formatMessage({
        id: "inventory.stockTake.sort.option.most_recently_reviewed",
        defaultMessage: "Most Recently Reviewed",
      }),
      field: StockTakeLotsSearchOrder.LastStockTakeAt,
      direction: StockTakeSearchOrderDirection.Desc,
    },
    [OngoingStockTakeSearchOrder.ExpiryDate]: {
      label: formatMessage({
        id: "inventory.stockTake.sort.option.expiry_date",
        defaultMessage: "Expiry Date",
      }),
      field: StockTakeLotsSearchOrder.ExpiryDate,
    },
  };
}

export default useSortByOptions;
